export const ADD_APPLICATION_CONFIG = 'addApplicationsConfig';
export const ADD_APPLICATION_HASH_CONFIG = 'addApplicationsHashConfig';
export const SHOW_LIST = 'showList';
export const ADD_PROCESS = 'addProcess';
export const ADD_PROCESS_WITH_HASH = 'addProcessWithHash';
export const WINDOWS = 'WINDOWS';
export const MACOS = 'MACOS';
export const ADD_SOFTWARE = 'ADD_SOFTWARE';
export const REMOVE_SOFTWARE = 'REMOVE_SOFTWARE';
export const ADD_SOFTWARE_WITH_HASHES = 'ADD_SOFTWARE_WITH_HASHES';
export const ADD_HASHES = 'ADD_HASHES';
export const REMOVE_HASHES = 'REMOVE_HASHES';
